import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { NEW_ROUTE_PATH, ROUTE_PATH } from '../../../../config/paths';
import { ROUTE_COLUMNS } from '../../../../config/columns';
import { clearRoutes, getRoutes } from '../../../../actions';

export const Routes = ({
  breadcrumbs,
  routes,
  loading,
  dispatchGetRoutes,
  dispatchClearRoutes,
}) => {
  useLayoutEffect(() => () => dispatchClearRoutes(), []);

  const data = routes.get('content') || [];
  const pages = routes.get('totalPages') || null;
  const defaultPageSize = routes.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Lista de Rutas"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_ROUTE_PATH}
      tableStructure={{
        columns: ROUTE_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetRoutes,
        modelPath: ROUTE_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetRoutes: getRoutes,
  dispatchClearRoutes: clearRoutes,
};

const mapStateToProps = ({ RouteUnit }) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Rutas',
      href: ROUTE_PATH,
    },
  ],
  routes: RouteUnit.Route.getIn(['all', 'content']),
  loading: RouteUnit.Route.getIn(['all', 'loading']),
});

Routes.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  routes: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetRoutes: PropTypes.func.isRequired,
  dispatchClearRoutes: PropTypes.func.isRequired,
};

Routes.defaultProps = {
  routes: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
